import React from "react";
import { RiAddLine } from "react-icons/ri";
import Button from "../Button/Button";

/**
 * Common Add Button component.
 * Renders a square icon button with a "+" icon, used for add actions across the app.
 * Pass `label` to show text to the left of the icon inside one button (optional).
 *
 * @param {object}   props
 * @param {function} props.onClick          – Click handler
 * @param {string}   [props.tooltip]        – Tooltip text shown on hover (icon-only mode)
 * @param {string}   [props.label]          – Optional visible label left of the "+" icon
 * @param {string}   [props.tooltipPosition] – "right" to anchor tooltip to the right edge (prevents cut-off)
 * @param {string}   [props.className]      – Additional CSS classes (e.g. "mt-4")
 */
const AddButton = ({ onClick, tooltip, label, tooltipPosition, className = "", name = "" }) => {
  const tooltipClass = tooltipPosition === "right" ? "tooltip-right" : "";
  const ariaLabel = label || name || tooltip || "Add";

  if (label) {
    return (
      <Button
        type="button"
        variant="neutral"
        size="sm"
        className={`btn-reset inline-flex items-center justify-end gap-2 px-3 py-1 h-[30px] ${className}`.trim()}
        onClick={onClick}
        name={name}
        aria-label={ariaLabel}
        title={ariaLabel}
      >
        <span className="whitespace-nowrap text-sm font-semibold text-text-primary">{label}</span>
        <RiAddLine className="text-2xl shrink-0 text-text-secondary" />
      </Button>
    );
  }

  return (
    <Button
      type="button"
      className={`btn-reset square-btn ${tooltipClass} ${className}`.trim()}
      onClick={onClick}
      name={name}
      aria-label={ariaLabel}
      title={ariaLabel}
      data-tooltipp={tooltip}
    >
      <RiAddLine className="text-2xl" />
    </Button>
  );
};

export default AddButton;
